/* ============================================================================
   McDuffy — Member Setup ("Bella's Club")  ·  post-pay welcome + seed flow
   ----------------------------------------------------------------------------
   Sits after PayMongo pay, before the live thank-you page. Reuses the quiz-v2
   "tails-look" (blue/Hanken/Inter, ✓-pop reward, bottom-sheet, running-dog
   progress). Canonical store = Railway (/api/dog-profiles). Identity = the
   buyer's email from checkout (localStorage `mcduffy_subscribe_config`) — they're
   already "logged in" from the quiz, so we never re-ask.

   Every add MERGES onto the record (we POST the full loaded profile + the new
   field); the backend also merge-preserves member fields + write-only ad fields,
   so nothing a step doesn't touch gets wiped. Save-anytime: each confirm waits for
   the server, then mirrors the confirmed profile locally for resume; the footer skip
   link always forwards to the order confirmation. NOTHING here re-touches billing.
   ============================================================================ */
(function () {
  'use strict';

  var root = document.getElementById('mcduffy-member-setup-root');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) { cfg = {}; }
  var BACKEND = (cfg.backendUrl || 'https://mcduffy-backend-production.up.railway.app').replace(/\/$/, '');
  var THANKYOU = cfg.thankYouUrl || '/pages/paymongo-return';
  var ACCOUNT = cfg.accountUrl || '/pages/account';
  var SLA_DAYS = parseInt(cfg.slaBusinessDays, 10) || 3;
  var LS_CFG = 'mcduffy_subscribe_config';
  var LS_RESUME = 'mcduffy_member_setup';

  /* ---------- tiny helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function api(method, path, body) {
    return fetch(BACKEND + path, {
      method: method, headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined, keepalive: true
    }).then(function (r) { return r.ok ? r.json().catch(function () { return {}; }) : Promise.reject(new Error('http ' + r.status)); });
  }
  function readJSON(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function writeJSON(key, v) { try { localStorage.setItem(key, JSON.stringify(v)); } catch (e) {} }
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime()); var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) added++; } /* deliver Mon–Sat (skip Sun) */
    return d;
  }
  function fmtDay(d) { return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function fmtBirthday(iso) { if (!iso) return ''; var p = String(iso).split('-'); if (p.length !== 3) return iso; var d = new Date(+p[0], +p[1] - 1, +p[2]); if (isNaN(d)) return iso; return MONTHS[d.getMonth()] + ' ' + d.getDate(); }

  /* ---------- inline icon set (stroke = currentColor) ---------- */
  var I = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>',
    dog: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 5.5 7 4 6 7l-2 1v6l2 2v3h3l1-2h4l1 2h3v-3l1-2v-4l-2-2V4l-3 1.5c-1.3-.6-3.7-.6-5 0z"/><circle cx="10" cy="11" r="1"/><circle cx="14" cy="11" r="1"/></svg>',
    camera: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h3l1.5-2h7L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.2"/></svg>',
    vaccine: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3l6 6M18 6l-9 9-4 1 1-4 9-9M9 12l3 3"/></svg>',
    vet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3v5a4 4 0 008 0V3"/><path d="M14 12a4 4 0 014 4v2a3 3 0 01-6 0"/><circle cx="6" cy="3" r="1"/><circle cx="14" cy="3" r="1"/></svg>',
    chip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="7" height="7" rx="1"/><rect x="4" y="13" width="7" height="7" rx="1"/><rect x="13" y="4" width="7" height="7" rx="1"/><path d="M13 15h3v3M19 13v.01M19 19v.01M16 19v.01"/></svg>',
    cake: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16M5 20v-6a3 3 0 013-3h8a3 3 0 013 3v6M4 15c1.5 1.5 3 1.5 4 0s2.5-1.5 4 0 2.5 1.5 4 0 2.5-1.5 4 0M12 8V5M12 5l1-1-1-1-1 1z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    crown: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8l3 8h10l3-8-4 3-4-6-4 6z"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7-4.5-7-10a3.5 3.5 0 017-2 3.5 3.5 0 017 2c0 5.5-7 10-7 10z"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v6c0 5-3.5 8-7 9-3.5-1-7-4-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>'
  };

  var RECIPE_LABEL = { chicken_rice: 'Chicken It Up', beef_rice: 'Braised Beef Bowl', pork_rice: 'Hearty Pork Rice', surf_turf: 'Surf & Turf', farmyard_feast: 'Farmyard Feast', coastal_blend: 'Coastal Blend' };
  function recipeLabel(k) { return RECIPE_LABEL[k] || pr('{her} McDuffy plan'); }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  /* Dog pronouns from the quiz sex answer — boy dogs were getting "Add her photo".
     Copy carries tokens; pr() resolves at render time (server dog_sex refines
     after hydrate). Unknown sex → gender-neutral. Tokens:
       {her}/{Her}  possessive  → his / her / their
       {she}/{She}  subject     → he / she / they
       {herm}       object      → him / her / them   */
  function pr(s) {
    var g = String((state.profile && state.profile.dog_sex) || '').toLowerCase();
    var boy = g === 'boy', girl = g === 'girl' || (g && g !== 'boy');
    var poss = boy ? 'his' : girl ? 'her' : 'their';
    var subj = boy ? 'he' : girl ? 'she' : 'they';
    var obj = boy ? 'him' : girl ? 'her' : 'them';
    function C(x) { return x.charAt(0).toUpperCase() + x.slice(1); }
    return String(s)
      .replace(/\{Her\}/g, C(poss)).replace(/\{her\}/g, poss)
      .replace(/\{She\}/g, C(subj)).replace(/\{she\}/g, subj)
      .replace(/\{herm\}/g, obj);
  }

  /* ---------- state ---------- */
  var state = {
    email: '',
    dog: 'your dog',
    profile: null,      // canonical record (merged from checkout config + GET)
    photoUrl: '',       // session-only preview (server storage deferred — see note)
    resume: readJSON(LS_RESUME) || {}
  };

  /* ---------- identity + load ---------- */
  function bootstrapFromConfig() {
    var c = readJSON(LS_CFG) || {};
    state.email = (c.email || c.parentEmail || (c.dogProfile && c.dogProfile.parentEmail) || '').trim();
    // Auto-login post-checkout (blueprint Easy-Win 1): the buyer just paid with this
    // email (the member page already verified the charge), so seed the exact session
    // key the account portal reads on load — they arrive at /pages/account already
    // signed in instead of re-typing their email. Mirrors the portal's own trust model.
    if (state.email) { try { sessionStorage.setItem('mcduffy_account_email', state.email); } catch (e) {} }
    var dp = c.dogProfile || (c.dogs && c.dogs[0] && c.dogs[0].dogProfile) || {};
    state.dog = (dp.name || (c.dogs && c.dogs[0] && c.dogs[0].name) || 'your dog');
    // seed a minimal profile so the UI can render before the GET lands
    state.profile = {
      email: state.email,
      dog_name: dp.name || '',
      dog_breed: dp.breed || '',
      dog_sex: dp.sex || dp.gender || '',
      dog_weight_kg: dp.weight || '',
      preferred_protein: c.recipe || dp.recipe || (dp.recipes && dp.recipes[0]) || '',
      parent_name: c.parentName || dp.parentName || '',
      household: {}
    };
  }
  function hydrateFromServer() {
    if (!state.email) return Promise.resolve();
    return api('GET', '/api/dog-profiles?email=' + encodeURIComponent(state.email))
      .then(function (p) {
        if (p && typeof p === 'object') {
          var name = state.profile.dog_name;
          var localMember = { vaccines: state.profile.vaccines, vet: state.profile.vet, microchip: state.profile.microchip, household: state.profile.household };
          state.profile = Object.assign({}, state.profile, p); // server-authoritative base
          state.profile.email = state.email;
          if (!state.profile.dog_name && name) state.profile.dog_name = name;
          if (state.profile.dog_name) state.dog = state.profile.dog_name;
          if (!state.profile.household || typeof state.profile.household !== 'object') state.profile.household = {};
          if (state.profile.photo_url && !state.photoUrl) state.photoUrl = state.profile.photo_url; // show stored photo on revisit
          // rare boot race: if the user already added something this session, don't let the GET clobber it
          if (state._touched) {
            if (localMember.vaccines && localMember.vaccines.length) state.profile.vaccines = localMember.vaccines;
            if (localMember.vet) state.profile.vet = localMember.vet;
            if (localMember.microchip) state.profile.microchip = localMember.microchip;
            if (localMember.household && localMember.household.birthday) state.profile.household = Object.assign({}, state.profile.household, localMember.household);
          }
        }
      })
      .catch(function () { /* offline-tolerant: keep the config seed */ });
  }

  /* curated PH vet-clinic seed for the typeahead (free-text is always allowed) */
  var VET_CLINICS = ['Vets in Practice — BGC', 'Vets in Practice — Alabang', 'Makati Dog & Cat Hospital', 'Animal House Veterinary Clinic — QC', 'Pet Express Veterinary Clinic', 'CARA Welfare Veterinary — QC', 'Metropolitan Veterinary Clinic — Makati', 'St. Rock Animal Hospital', 'Animal Kingdom Veterinary Clinic', 'The Pet Project Veterinary — Marikina', 'Petmatters Veterinary — Mandaluyong', 'VetCentral — Ortigas', 'Better Choice Animal Clinic', 'Halo Halo Vet — Pasig', 'Cainta Veterinary Clinic', 'Paws & Claws Veterinary — Las Piñas', 'Alabang Veterinary Clinic', 'Sunny Day Veterinary — Parañaque', 'North Caloocan Veterinary', 'A. Menandro Veterinary Clinic'];

  /* ---------- steps — each is a PRIVILEGE the owner unlocks. Copy leads with the
     reward (what they GET); the ask is secondary. `cta` = benefit-led save button. ---------- */
  var STEPS = [
    {
      id: 'photo', icon: I.camera,
      reward: 'Bring {her} card to life', ask: 'Add a photo', cta: 'Put {her} on the card',
      doneReward: '{Her} card is live', doneNote: 'photo added',
      done: function () { return !!state.photoUrl; },
      perk: { icon: I.heart, text: '{Her} member card is alive now ✨' },
      prompt: function () { return 'Put a face to <span class="ms-uline">' + esc(state.dog) + '</span>'; },
      render: function (body, setValid) {
        body.innerHTML =
          '<div class="mds-photo">' +
            '<label class="mds-photo__preview" for="mds-photo-in" id="mds-photo-prev">' + I.camera + '</label>' +
            '<div><button type="button" class="mds-chip" id="mds-photo-btn">Choose a photo</button>' +
            '<p style="font-size:12px;color:var(--ms-muted);margin:8px 0 0">A clear, happy one works best.</p></div>' +
          '</div>' +
          '<input type="file" id="mds-photo-in" accept="image/*">';
        var input = body.querySelector('#mds-photo-in');
        var prev = body.querySelector('#mds-photo-prev');
        body.querySelector('#mds-photo-btn').addEventListener('click', function () { input.click(); });
        input.addEventListener('change', function () {
          var f = input.files && input.files[0]; if (!f) return;
          var rd = new FileReader();
          rd.onload = function () {
            var img = new Image();
            img.onload = function () {
              // cover-crop to a 256px square + re-encode → small enough to store cheaply
              var S = 256, c = document.createElement('canvas'); c.width = S; c.height = S;
              var ctx = c.getContext('2d'), side = Math.min(img.width, img.height);
              ctx.drawImage(img, (img.width - side) / 2, (img.height - side) / 2, side, side, 0, 0, S, S);
              var out = c.toDataURL('image/jpeg', 0.72);
              state._pendingPhoto = out; prev.innerHTML = '<img alt="" src="' + out + '">'; setValid(true);
            };
            img.onerror = function () { setValid(false); };
            img.src = rd.result;
          };
          rd.readAsDataURL(f);
        });
        setValid(false);
      },
      collect: function () {
        var d = state._pendingPhoto || ''; state._pendingPhoto = '';
        if (!d) return null;
        return { __photoDataUrl: d }; // persist() must confirm /api/dog-photos before reward
      }
    },
    {
      id: 'vaccines', icon: I.vaccine,
      reward: 'Never miss a shot again', ask: 'Snap the card or add the dates', cta: 'Turn on {her} reminders',
      doneReward: 'Shot reminders are on', doneNote: '',
      done: function () { return (state.profile.vaccines || []).length > 0; },
      perk: { icon: I.shield, text: 'Reminders on — we’ll never let a shot lapse' },
      prompt: function () { return 'Never miss ' + esc(state.dog) + '’s <span class="ms-uline">shots</span>'; },
      render: function (body, setValid) {
        var KNOWN = ['Rabies', '5-in-1 (DHPPi)', 'Kennel cough', 'Deworming'];
        /* working list — a row per shot, each with its OWN due date. Seeded from
           the saved record so re-opening shows what's there and lets you add more. */
        var rows = (state.profile.vaccines || []).map(function (v) { return { name: v.name || '', due: v.due_date || '' }; });
        body.innerHTML =
          '<button type="button" class="mds-scan" id="mds-vax-scan">' + I.camera +
            '<span class="mds-scan__tx"><b>Snap ' + esc(state.dog) + '’s vaccine card</b><em>We read every shot &amp; date off the photo for you</em></span>' + I.chev + '</button>' +
          '<div class="mds-scan-prev" id="mds-vax-prev" hidden></div>' +
          '<input type="file" id="mds-vax-file" accept="image/*" capture="environment" hidden>' +
          '<div class="mds-or"><span>or add shots one by one</span></div>' +
          '<div id="mds-vax-rows"></div>' +
          '<div class="mds-chips" id="mds-vax-add">' +
            KNOWN.map(function (v) { return '<button type="button" class="mds-chip mds-chip--add" data-add="' + esc(v) + '">+ ' + esc(v) + '</button>'; }).join('') +
            '<button type="button" class="mds-chip mds-chip--add" data-add-custom>+ Other</button>' +
          '</div>';
        var rowsEl = body.querySelector('#mds-vax-rows');
        function refresh() { setValid(rows.some(function (r) { return r.name && r.name.trim(); })); }
        function renderRows() {
          rowsEl.innerHTML = rows.map(function (r, i) {
            return '<div class="mds-vaxrow" data-i="' + i + '">' +
              '<input class="mds-input mds-vaxrow__name" data-name value="' + esc(r.name) + '" placeholder="Shot name">' +
              '<div class="mds-vaxrow__d"><span class="mds-vaxrow__lbl">next due</span><input class="mds-input mds-vaxrow__date" type="date" data-date value="' + esc(r.due || '') + '"></div>' +
              '<button type="button" class="mds-vaxrow__rm" data-rm aria-label="Remove ' + esc(r.name || 'shot') + '">&times;</button>' +
              '</div>';
          }).join('');
          refresh();
        }
        function addRow(name, due, focusDate) {
          rows.push({ name: name || '', due: due || '' }); renderRows();
          var last = rowsEl.querySelector('.mds-vaxrow:last-child .mds-vaxrow__' + (focusDate ? 'date' : 'name'));
          if (last) { try { last.focus(); } catch (e) {} }
        }
        body.querySelector('#mds-vax-add').addEventListener('click', function (e) {
          var b = e.target.closest('[data-add]');
          if (b) {
            var nm = b.getAttribute('data-add') || '';
            // Dedup: don't add a second "Rabies" row — focus the existing one instead (mirrors the scan path)
            var iEx = rows.findIndex ? rows.findIndex(function (r) { return r.name.toLowerCase() === nm.toLowerCase(); }) : -1;
            if (nm && iEx > -1) { var ex = rowsEl.querySelector('.mds-vaxrow[data-i="' + iEx + '"] .mds-vaxrow__date'); if (ex) { try { ex.focus(); } catch (er) {} } return; }
            addRow(nm, '', true); return;
          }
          if (e.target.closest('[data-add-custom]')) addRow('', '', false);
        });
        rowsEl.addEventListener('input', function (e) {
          var row = e.target.closest('.mds-vaxrow'); if (!row) return; var i = +row.getAttribute('data-i');
          if (e.target.hasAttribute('data-name')) rows[i].name = e.target.value;
          if (e.target.hasAttribute('data-date')) rows[i].due = e.target.value;
          refresh();
        });
        rowsEl.addEventListener('click', function (e) {
          if (e.target.closest('[data-rm]')) { var row = e.target.closest('.mds-vaxrow'); rows.splice(+row.getAttribute('data-i'), 1); renderRows(); }
        });
        /* Claude-vision: snap the card → we read EVERY shot + its date into its own row */
        var scanBtn = body.querySelector('#mds-vax-scan'), file = body.querySelector('#mds-vax-file'), prev = body.querySelector('#mds-vax-prev');
        function cleanName(n) { var s = String(n || '').toLowerCase(); if (/rab/.test(s)) return 'Rabies'; if (/5|penta|dhpp|distemper|parvo|hepatitis/.test(s)) return '5-in-1 (DHPPi)'; if (/kennel|bordetella|cough|tracheo/.test(s)) return 'Kennel cough'; if (/deworm|worm|drontal|anthelmintic/.test(s)) return 'Deworming'; return String(n || '').trim(); }
        scanBtn.addEventListener('click', function () { file.click(); });
        file.addEventListener('change', function () {
          var f = file.files && file.files[0]; if (!f) return;
          var rd = new FileReader();
          rd.onload = function () {
            var img = new Image();
            img.onload = function () {
              var MAX = 1500, scale = Math.min(1, MAX / Math.max(img.width, img.height));
              var cw = Math.round(img.width * scale), ch = Math.round(img.height * scale);
              var c = document.createElement('canvas'); c.width = cw; c.height = ch;
              c.getContext('2d').drawImage(img, 0, 0, cw, ch);
              var dataUrl = c.toDataURL('image/jpeg', 0.82);
              prev.hidden = false;
              prev.innerHTML = '<img alt="' + esc(state.dog) + ' vaccine card" src="' + dataUrl + '"><span class="mds-scan__reading"><span class="mds-mini-spin"></span> Reading ' + esc(state.dog) + '’s card…</span>';
              scanBtn.classList.add('is-done');
              var noteEl = prev.querySelector('.mds-scan__reading');
              fetch(BACKEND + '/api/vision/extract', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ image: dataUrl, kind: 'vaccine' }) })
                .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
                .then(function (j) {
                  if (!(j && j.ok && j.data)) { if (noteEl) noteEl.innerHTML = 'Couldn’t read it clearly — add the shots below instead.'; return; }
                  var vax = (j.data.vaccines || []).filter(function (v) { return v && v.name; });
                  var added = 0;
                  vax.forEach(function (v) {
                    var nm = cleanName(v.name), due = v.due_date || '';
                    var exists = rows.some(function (r) { return r.name.toLowerCase() === nm.toLowerCase(); });
                    if (!exists) { rows.push({ name: nm, due: due }); added++; }
                  });
                  renderRows();
                  if (noteEl) noteEl.innerHTML = added ? (I.check + ' Read ' + added + ' shot' + (added === 1 ? '' : 's') + ' — check the dates &amp; save.') : 'Got the photo — add the shots below.';
                })
                .catch(function () { if (noteEl) noteEl.innerHTML = 'Couldn’t read it just now — add the shots below instead.'; });
            };
            img.onerror = function () { prev.hidden = false; prev.innerHTML = '<span class="mds-scan__reading">Couldn’t open that image — try another photo.</span>'; };
            img.src = rd.result;
          };
          rd.readAsDataURL(f);
        });
        body._collect = function () { return { rows: rows }; };
        renderRows();
      },
      collect: function (body) {
        var v = body._collect ? body._collect() : { rows: [] };
        var list = [], seen = {};
        (v.rows || []).forEach(function (r) {
          if (!(r.name && r.name.trim())) return;
          var nm = r.name.trim(), key = nm.toLowerCase();
          if (seen[key]) return; // never persist duplicate shots → no double reminders
          seen[key] = 1; list.push({ name: nm, due_date: r.due || '' });
        });
        state.profile.vaccines = list;
        return { vaccines: list };
      }
    },
    {
      id: 'vet', icon: I.vet,
      reward: '{Her} vet, one tap away', ask: 'Add the clinic', cta: 'Save {her} vet',
      doneReward: 'Vet saved', doneNote: '',
      done: function () { return !!(state.profile.vet && (state.profile.vet.clinic || state.profile.vet.phone)); },
      perk: { icon: I.vet, text: 'Call or share records in one tap now' },
      prompt: function () { return 'Who’s ' + esc(state.dog) + '’s <span class="ms-uline">vet</span>?'; },
      render: function (body, setValid) {
        var v = state.profile.vet || {};
        body.innerHTML =
          '<div class="mds-field mds-typeahead"><label class="mds-label" for="mds-vet-clinic">Clinic</label>' +
            '<input class="mds-input" id="mds-vet-clinic" autocomplete="off" placeholder="Start typing — e.g. Vets in Practice" value="' + esc(v.clinic || '') + '">' +
            '<ul class="mds-ta-list" id="mds-vet-list" hidden></ul></div>' +
          '<div class="mds-field"><label class="mds-label" for="mds-vet-phone">Phone <span style="color:var(--ms-muted);font-weight:600">(optional)</span></label><input class="mds-input" id="mds-vet-phone" type="tel" inputmode="tel" placeholder="0917…" value="' + esc(v.phone || '') + '"></div>';
        var clinic = body.querySelector('#mds-vet-clinic');
        var phone = body.querySelector('#mds-vet-phone');
        var list = body.querySelector('#mds-vet-list');
        function refresh() { setValid(!!clinic.value.trim() || !!phone.value.trim()); }
        function closeList() { list.hidden = true; list.innerHTML = ''; }
        function suggest() {
          var q = clinic.value.trim().toLowerCase();
          if (q.length < 2) { closeList(); return; }
          var hits = VET_CLINICS.filter(function (c) { return c.toLowerCase().indexOf(q) > -1; }).slice(0, 6);
          if (!hits.length) { closeList(); return; }
          list.innerHTML = hits.map(function (c) { return '<li data-pick="' + esc(c) + '">' + esc(c) + '</li>'; }).join('');
          list.hidden = false;
        }
        clinic.addEventListener('input', function () { suggest(); refresh(); });
        clinic.addEventListener('focus', suggest);
        list.addEventListener('mousedown', function (e) { var li = e.target.closest('[data-pick]'); if (!li) return; e.preventDefault(); clinic.value = li.getAttribute('data-pick'); closeList(); refresh(); });
        clinic.addEventListener('blur', function () { setTimeout(closeList, 120); });
        phone.addEventListener('input', refresh);
        body._collect = function () { return { clinic: clinic.value.trim(), phone: phone.value.trim() }; };
        refresh();
      },
      collect: function (body) {
        var d = body._collect ? body._collect() : {};
        state.profile.vet = Object.assign({}, state.profile.vet, { clinic: d.clinic, phone: d.phone });
        return { vet: state.profile.vet };
      }
    },
    {
      id: 'microchip', icon: I.chip,
      reward: 'Lost-dog safety net', ask: 'Add {her} chip number', cta: 'Turn on {her} safety net',
      doneReward: 'Safety net is on', doneNote: '',
      done: function () { return !!state.profile.microchip; },
      perk: { icon: I.shield, text: 'If {she} ever gets lost, {her} tag brings {herm} home' },
      prompt: function () { return 'What’s ' + esc(state.dog) + '’s <span class="ms-uline">chip</span> number?'; },
      render: function (body, setValid) {
        body.innerHTML =
          '<input class="mds-input" id="mds-chip" inputmode="text" autocomplete="off" placeholder="15-digit number" value="' + esc(state.profile.microchip || '') + '">' +
          '<p style="font-size:12px;color:var(--ms-muted);margin:8px 0 0">' + pr('It’s on {her} vet card or adoption papers. Powers {her} lost-pet tag + travel ID.') + '</p>';
        var el = body.querySelector('#mds-chip');
        el.addEventListener('input', function () { setValid(el.value.replace(/[^0-9A-Za-z]/g, '').length >= 6); });
        body._collect = function () { return el.value.replace(/[^0-9A-Za-z-]/g, ''); };
        setValid((state.profile.microchip || '').length >= 6);
      },
      collect: function (body) { var v = body._collect ? body._collect() : ''; state.profile.microchip = v; return { microchip: v }; }
    },
    {
      id: 'birthday', icon: I.cake,
      reward: 'A birthday treat, on us', ask: 'Add {her} birthday', cta: 'Lock in {her} treat',
      doneReward: 'Birthday treat locked in', doneNote: '',
      done: function () { return !!(state.profile.household && state.profile.household.birthday); },
      perk: { icon: I.cake, text: 'A free birthday treat rides {her} box that month 🎂' },
      prompt: function () { return 'When’s ' + esc(state.dog) + '’s <span class="ms-uline">birthday</span>?'; },
      render: function (body, setValid) {
        body.innerHTML =
          '<input class="mds-input" type="date" id="mds-bday" value="' + esc((state.profile.household && state.profile.household.birthday) || '') + '">' +
          '<p style="font-size:12px;color:var(--ms-muted);margin:8px 0 0">' + pr('Don’t know the exact day? {Her} adoption day works too.') + '</p>';
        var el = body.querySelector('#mds-bday');
        el.addEventListener('change', function () { setValid(!!el.value); });
        body._collect = function () { return el.value; };
        setValid(!!(state.profile.household && state.profile.household.birthday));
      },
      collect: function (body) {
        var v = body._collect ? body._collect() : '';
        state.profile.household = Object.assign({}, state.profile.household, { birthday: v });
        return { household: state.profile.household };
      }
    }
  ];

  function doneCount() { var n = 0; STEPS.forEach(function (s) { if (s.done()) n++; }); return n; }
  function pct() { return Math.round(((1 + doneCount()) / (1 + STEPS.length)) * 100); } /* +1 = the plan, already set from the quiz */

  /* ---------- persistence ---------- */
  function persist(patch) {
    if (!state.email) return Promise.reject(new Error('missing member email'));
    if (patch && patch.__photoDataUrl) {
      return api('POST', '/api/dog-photos', { email: state.email, dataUrl: patch.__photoDataUrl })
        .then(function (result) {
          if (!(result && result.url)) throw new Error('photo upload was not confirmed');
          state.photoUrl = result.url;
          state.profile.photo_url = result.url;
          writeJSON(LS_RESUME, { email: state.email, at: Date.now(), profile: slimProfile() });
          return result;
        });
    }
    // Preserve the funnel stage, but never send 'quiz_email_captured' — that would
    // re-fire the CAPI CompleteRegistration on the backend. Post-checkout writes are 'profile_saved'.
    var safeLead = (state.profile.lead_status && state.profile.lead_status !== 'quiz_email_captured') ? state.profile.lead_status : 'profile_saved';
    var body = Object.assign({}, state.profile, { email: state.email, source: state.profile.source || 'member_setup', lead_status: safeLead }, patch || {});
    return api('POST', '/api/dog-profiles', body).then(function (result) {
      writeJSON(LS_RESUME, { email: state.email, at: Date.now(), profile: slimProfile() });
      return result;
    });
  }
  function slimProfile() { var p = Object.assign({}, state.profile); return p; }

  /* ---------- rendering: welcome ---------- */
  function mount(html) { root.innerHTML = html; }

  /* named status tiers (LinkedIn profile-strength pattern) — status, not just a % */
  function memberLevel() {
    var d = doneCount();
    if (d >= STEPS.length) return 'Full member';
    if (d >= 3) return 'Gold paw';
    if (d >= 1) return 'Rising star';
    return 'New member';
  }
  function memberCardHTML() {
    var avatar = state.photoUrl ? '<img alt="" src="' + esc(state.photoUrl) + '">' : I.dog;
    var left = STEPS.length - doneCount();
    var gradient = left === 0 ? 'Everything’s unlocked 🎉'
      : left === 1 ? 'Just 1 unlock from ' + esc(state.dog) + '’s full passport'
      : left + ' unlocks from ' + esc(state.dog) + '’s full passport';
    return '<div class="mds-mcard' + (state.photoUrl ? ' is-live' : '') + '">' +
        '<div class="mds-mcard__top">' +
          '<div class="mds-mcard__id"><div class="mds-mcard__avatar">' + avatar + '</div>' +
            '<div><div class="mds-mcard__eyebrow">McDUFFY · ' + esc(memberLevel().toUpperCase()) + '</div><div class="mds-mcard__name">' + esc(state.dog) + '’s Club</div></div></div>' +
          '<div class="mds-mcard__pct"><b>' + pct() + '%</b><span>built</span></div>' +
        '</div>' +
        '<div class="mds-prog"><div class="mds-prog__fill" style="width:' + pct() + '%"></div>' +
          '<div class="mds-prog__dog" style="left:' + pct() + '%">' + I.dog + '</div></div>' +
        '<div class="mds-mcard__goal">' + gradient + '</div>' +
      '</div>';
  }

  function rowHTML(step) {
    var isDone = step.done();
    /* undone: the REWARD leads (what they GET), the ask is the small print.
       done: the unlocked privilege + its tangible result. */
    var title = pr(isDone ? step.doneReward : step.reward);
    var sub = isDone ? doneSubtitle(step) : pr(step.ask);
    return '<button type="button" class="mds-row' + (isDone ? ' is-done' : '') + '" data-step="' + step.id + '"' + (isDone ? ' aria-label="' + esc(title) + ' — unlocked"' : '') + '>' +
        '<span class="mds-row__ic">' + (isDone ? I.check : step.icon) + '</span>' +
        '<span class="mds-row__body"><span class="mds-row__t">' + esc(title) + '</span><span class="mds-row__s">' + esc(sub) + '</span></span>' +
        '<span class="mds-row__chev' + (isDone ? ' mds-row__chev--edit' : '') + '">' + (isDone ? 'Edit' : 'Unlock ' + I.chev) + '</span>' +
      '</button>';
  }
  function doneSubtitle(step) {
    if (step.id === 'vaccines') { var n = (state.profile.vaccines || []).length; return n + ' reminder' + (n === 1 ? '' : 's') + ' scheduled'; }
    if (step.id === 'vet') { return (state.profile.vet && state.profile.vet.clinic) || 'call & share in one tap'; }
    if (step.id === 'microchip') { return 'lost-dog tag active'; }
    if (step.id === 'birthday') { return 'treat set for ' + (fmtBirthday(state.profile.household && state.profile.household.birthday) || 'the big day'); }
    if (step.id === 'photo') { return 'on ' + pr('{her}') + ' member card'; }
    return 'unlocked';
  }

  function remindersHTML() {
    var vax = (state.profile.vaccines || []).filter(function (v) { return v && v.due_date; })
      .sort(function (a, b) { return String(a.due_date).localeCompare(String(b.due_date)); }).slice(0, 2);
    if (!vax.length) return '';
    return '<div class="mds-list" style="margin-bottom:12px">' +
      '<div style="padding:11px 2px 5px;font-family:var(--ms-display);font-weight:800;font-size:13px;color:var(--ms-blue-ink)">Coming up</div>' +
      vax.map(function (v) {
        return '<div class="mds-row" style="cursor:default"><span class="mds-row__ic">' + I.vaccine + '</span>' +
          '<span class="mds-row__body"><span class="mds-row__t">' + esc(v.name) + '</span>' +
          '<span class="mds-row__s">due ' + esc(String(v.due_date).slice(0, 10)) + '</span></span></div>';
      }).join('') + '</div>';
  }

  function renderWelcome() {
    if (doneCount() === STEPS.length) return renderDone();
    var eta = addBusinessDays(new Date(), SLA_DAYS);
    var firstTodo = null; for (var i = 0; i < STEPS.length; i++) { if (!STEPS[i].done()) { firstTodo = STEPS[i]; break; } }
    var planRow =
      '<div class="mds-row is-done" aria-hidden="true" style="cursor:default">' +
        '<span class="mds-row__ic">' + I.check + '</span>' +
        '<span class="mds-row__body"><span class="mds-row__t">' + pr('{Her} custom plan') + '</span><span class="mds-row__s">' + esc(recipeLabel(state.profile.preferred_protein)) + ' — already yours</span></span>' +
      '</div>';
    var listHead = '<div class="mds-list__head">' +
      '<span>Claim ' + esc(state.dog) + '’s perks</span>' +
      '<span class="mds-list__count">' + (STEPS.length - doneCount()) + ' left</span></div>';

    mount(
      '<div class="mds-wrap">' +
        '<p class="mds-kicker">You’re in' + (state.profile.parent_name ? ', ' + esc(state.profile.parent_name.split(' ')[0]) : '') + '</p>' +
        '<h1 class="mds-title">' + esc(state.dog) + '’s first box is being cooked</h1>' +
        '<div class="mds-eta"><span class="mds-eta__icon">' + I.truck + '</span>' +
          '<div><div class="mds-eta__date">Arriving ' + esc(fmtDay(eta)) + '</div><div class="mds-eta__sub">We’ll text you tracking on Viber</div></div></div>' +
        memberCardHTML() +
        '<p class="mds-reciprocity">' + I.check + ' You’ve already unlocked ' + pr('{her}') + ' plan and delivery schedule. Claim the rest below — each one’s a real perk, not a form.</p>' +
        remindersHTML() +
        listHead +
        '<div class="mds-list">' + planRow + STEPS.map(rowHTML).join('') + '</div>' +
        (firstTodo ? '<button type="button" class="mds-cta" data-cta="' + firstTodo.id + '"><span class="mds-cta__lead">Unlock next</span><span class="mds-cta__main">' + esc(pr(firstTodo.reward)) + ' ' + I.arrow + '</span></button>' : '') +
      '</div>'
    );
  }
  function onWelcomeClick(e) {
    var cta = e.target.closest('[data-cta]');
    var row = e.target.closest('.mds-row[data-step]');
    var id = cta ? cta.getAttribute('data-cta') : (row ? row.getAttribute('data-step') : null);
    if (!id) return;
    var step = null; STEPS.forEach(function (s) { if (s.id === id) step = s; });
    if (step) openSheet(step);
  }

  /* ---------- bottom-sheet ---------- */
  var activeSheet = null;
  function openSheet(step) {
    closeSheet();
    var ov = document.createElement('div');
    ov.className = 'mds-sheet-ov';
    ov.innerHTML =
      '<div class="mds-sheet-ov__scrim" data-close></div>' +
      '<div class="mds-sheet" role="dialog" aria-modal="true">' +
        '<div class="mds-sheet__grip"></div>' +
        '<div class="mds-sheet__stage">' +
          '<p class="mds-sheet__kicker">' + esc(state.dog) + '’s Club</p>' +
          '<h2 class="mds-sheet__prompt">' + step.prompt() + '</h2>' +
          '<div class="mds-sheet__err" data-err></div>' +
          '<div class="mds-sheet__body" data-body></div>' +
          '<button type="button" class="mds-sheet__cta" data-confirm>' + esc(pr(step.cta || 'Save')) + ' ' + I.check + '</button>' +
          '<button type="button" class="mds-sheet__skip" data-skip>Skip — do it later</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    activeSheet = ov;

    var body = ov.querySelector('[data-body]');
    var confirm = ov.querySelector('[data-confirm]');
    var errorEl = ov.querySelector('[data-err]');
    var isValid = false;
    var saving = false;
    var ctaLabel = esc(pr(step.cta || 'Save')) + ' ' + I.check;
    /* The confirm button is ALWAYS enabled — never a dead/greyed button (owner
       directive: "don't require all info to continue — edit it later on the
       account page"). Empty → the button reads "Continue" and just advances
       (like Skip, no save, no wipe); a filled value persists + rewards. */
    step.render(body, function (ok) { isValid = !!ok; confirm.innerHTML = ok ? ctaLabel : 'Continue'; });
    if (!isValid) confirm.innerHTML = 'Continue';

    setTimeout(function () { ov.classList.add('is-in'); }, 20); /* not rAF — throttled in background/hidden tabs */

    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]') || e.target.closest('[data-skip]')) { closeSheet(); return; }
      if (e.target.closest('[data-confirm]')) {
        if (saving) return;
        if (!isValid) { closeSheet(); return; } // nothing filled → just continue (never blocks; edit later on the account page)
        var previousProfile = JSON.parse(JSON.stringify(state.profile || {}));
        var previousPhotoUrl = state.photoUrl;
        var patch;
        try { patch = step.collect(body); }
        catch (err) {
          if (errorEl) errorEl.textContent = 'We could not read that update. Please try again.';
          return;
        }
        state._touched = true;
        saving = true;
        confirm.disabled = true;
        confirm.textContent = 'Saving…';
        if (errorEl) errorEl.textContent = '';
        persist(patch).then(function () {
          showReward(ov, step);
        }).catch(function () {
          state.profile = previousProfile;
          state.photoUrl = previousPhotoUrl;
          if (patch && patch.__photoDataUrl) state._pendingPhoto = patch.__photoDataUrl;
          saving = false;
          confirm.disabled = false;
          confirm.innerHTML = ctaLabel;
          if (errorEl) errorEl.textContent = 'That was not saved. Nothing changed—please try again.';
        });
      }
    });
  }
  function closeSheet() {
    if (!activeSheet) return;
    var ov = activeSheet; activeSheet = null;
    ov.classList.remove('is-in');
    document.body.style.overflow = '';
    setTimeout(function () { if (ov && ov.parentNode) ov.parentNode.removeChild(ov); }, 240);
  }

  function showReward(ov, step) {
    var stage = ov.querySelector('.mds-sheet__stage');
    if (!stage) { closeSheet(); return; }
    /* reward reveal = a beat of anticipation, then the UNLOCKED privilege named.
       No confetti here — that's reserved for 100% so it stays special. */
    var newPct = pct();
    var left = STEPS.length - doneCount();
    var closing = left > 0
      ? '<div class="mds-reward__next">' + (left === 1 ? 'One more unlock and ' + esc(state.dog) + '’s page is complete.' : left + ' more to unlock everything.') + '</div>'
      : '';
    stage.innerHTML =
      '<div class="mds-reward">' +
        '<div class="mds-reward__check">' + I.check + '</div>' +
        '<div class="mds-reward__unlocked">Unlocked</div>' +
        '<div class="mds-reward__t">' + esc(pr(step.perk.text)) + '</div>' +
        '<div class="mds-reward__bar"><div class="mds-reward__fill" style="width:' + newPct + '%"></div></div>' +
        '<div class="mds-reward__pct">' + esc(state.dog) + '’s page · ' + newPct + '% built</div>' +
        closing +
      '</div>';
    setTimeout(function () { closeSheet(); renderWelcome(); }, 1500);
  }
  function confettiHTML() {
    var cols = ['#16499C', '#2E9E6B', '#C5F7DE', '#7CC4F2'];
    var s = '<div class="mds-conf" aria-hidden="true">';
    for (var i = 0; i < 10; i++) {
      var left = 8 + Math.round((i / 9) * 84);
      s += '<i style="left:' + left + '%;background:' + cols[i % 4] + ';animation-delay:' + (0.2 + (i % 5) * 0.06).toFixed(2) + 's"></i>';
    }
    return s + '</div>';
  }

  /* ---------- completion ("full member") ---------- */
  function quickActionsHTML() {
    var v = state.profile.vet || {};
    var acts = [];
    if (v.phone) acts.push('<a class="mds-cta mds-cta--ghost" href="tel:' + esc(String(v.phone).replace(/[^0-9+]/g, '')) + '">' + I.vet + ' Call ' + esc(v.clinic || pr('{her} vet')) + '</a>');
    if (v.clinic || v.address) acts.push('<a class="mds-cta mds-cta--ghost" target="_blank" rel="noopener" href="https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(((v.clinic || '') + ' ' + (v.address || '')).trim()) + '">' + I.arrow + ' Directions to ' + pr('{her}') + ' vet</a>');
    return acts.length ? '<div style="display:flex;flex-direction:column;gap:8px;margin:10px 0 2px">' + acts.join('') + '</div>' : '';
  }

  function printPassport() {
    var p = state.profile || {};
    var vet = p.vet || {};
    var photo = state.photoUrl || p.photo_url || '';
    var age = p.dog_age ? (p.dog_age + ' yr' + (Number(p.dog_age) === 1 ? '' : 's')) : '';
    var subtitle = [p.dog_breed, age].filter(Boolean).join('  ·  ');
    var facts = [
      ['Weight', p.dog_weight_kg ? p.dog_weight_kg + ' kg' : ''],
      ['Fresh recipe', p.preferred_protein ? recipeLabel(p.preferred_protein) : ''],
      ['Birthday', fmtBirthday(p.household && p.household.birthday)],
      ['Microchip', p.microchip],
      ['Neutered', p.spayed_neutered === 'yes' ? 'Yes' : (p.spayed_neutered === 'no' ? 'No' : '')],
      ['Vet', vet.clinic || '']
    ].filter(function (r) { return r[1]; });
    var factGrid = facts.map(function (r) { return '<div class="fact"><span class="fact__k">' + esc(r[0]) + '</span><span class="fact__v">' + esc(r[1]) + '</span></div>'; }).join('');
    var vaxRows = (p.vaccines || []).map(function (v) {
      return '<tr><td class="vx">' + esc(v.name) + '</td><td>' + (v.given_date ? esc(String(v.given_date).slice(0, 10)) : '<span class="mut">—</span>') + '</td><td class="due">' + (v.due_date ? esc(String(v.due_date).slice(0, 10)) : '<span class="mut">—</span>') + '</td></tr>';
    }).join('');
    var vetContact = [vet.phone, vet.address].filter(Boolean).join('  ·  ');
    var avatar = photo ? '<img class="pp-ava" src="' + esc(photo) + '" alt="">' : '<div class="pp-ava pp-ava--ph">' + esc((state.dog || 'D').charAt(0).toUpperCase()) + '</div>';
    var html =
      '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">' +
      '<title>' + esc(state.dog) + ' — McDuffy Living Passport</title>' +
      '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>' +
      '<link href="https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@500;700;800;900&family=Inter:wght@400;600;700&display=swap" rel="stylesheet">' +
      '<style>' +
      ':root{--ink:#0F356F;--blue:#16499C;--mut:#5C6B7A;--line:#E6EEF7;--mint:#C5F7DE;--green:#1B7A4B;--paper:#F7FAFF}' +
      '*{box-sizing:border-box}' +
      'body{font-family:Inter,system-ui,sans-serif;color:#22303f;background:#EAF1FB;margin:0;padding:28px 14px}' +
      '.pp{max-width:660px;margin:0 auto;background:#fff;border-radius:22px;overflow:hidden;box-shadow:0 18px 50px rgba(15,53,111,.16)}' +
      '.pp-top{background:linear-gradient(135deg,#16499C,#0F356F);color:#fff;padding:26px 30px 30px;position:relative}' +
      '.pp-eyebrow{font-size:11px;letter-spacing:.14em;font-weight:700;color:var(--mint);text-transform:uppercase}' +
      '.pp-id{display:flex;align-items:center;gap:18px;margin-top:16px}' +
      '.pp-ava{width:92px;height:92px;border-radius:20px;object-fit:cover;border:3px solid rgba(255,255,255,.5);flex:0 0 auto;background:#dbe6f7}' +
      '.pp-ava--ph{display:flex;align-items:center;justify-content:center;font-family:"Hanken Grotesk",sans-serif;font-weight:900;font-size:40px;color:#9db8dd}' +
      '.pp-name{font-family:"Hanken Grotesk",sans-serif;font-weight:900;font-size:38px;line-height:1.02;margin:0}' +
      '.pp-sub{color:#CFE0F7;font-size:14px;margin-top:6px;font-weight:600}' +
      '.pp-chip{position:absolute;top:26px;right:30px;background:var(--mint);color:#12432F;font-weight:800;font-size:12px;padding:6px 12px;border-radius:99px}' +
      '.pp-body{padding:24px 30px 30px}' +
      '.pp-h{font-family:"Hanken Grotesk",sans-serif;font-weight:800;color:var(--ink);font-size:14px;text-transform:uppercase;letter-spacing:.05em;margin:0 0 12px}' +
      '.pp-grid{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:var(--line);border:1px solid var(--line);border-radius:14px;overflow:hidden;margin-bottom:26px}' +
      '.fact{background:#fff;padding:13px 15px;display:flex;flex-direction:column;gap:3px}' +
      '.fact__k{font-size:11px;font-weight:700;letter-spacing:.03em;text-transform:uppercase;color:var(--mut)}' +
      '.fact__v{font-family:"Hanken Grotesk",sans-serif;font-weight:700;font-size:16px;color:var(--ink)}' +
      '.vtab{width:100%;border-collapse:collapse;font-size:14px}' +
      '.vtab th{text-align:left;font-size:11px;letter-spacing:.03em;text-transform:uppercase;color:var(--mut);font-weight:700;padding:0 8px 8px}' +
      '.vtab td{padding:11px 8px;border-top:1px solid var(--line)}' +
      '.vtab .vx{font-weight:700;color:var(--ink)}' +
      '.vtab .due{font-weight:700;color:var(--green)}' +
      '.vtab .mut{color:#AAB6C4}' +
      '.pp-vet{background:var(--paper);border-radius:14px;padding:14px 16px;margin-bottom:22px}' +
      '.pp-vet b{font-family:"Hanken Grotesk",sans-serif;color:var(--ink)}' +
      '.pp-vet div{color:var(--mut);font-size:13px;margin-top:2px}' +
      '.pp-foot{color:var(--mut);font-size:11.5px;line-height:1.55;border-top:1px solid var(--line);padding-top:16px}' +
      '.pbtn{display:block;width:100%;margin:22px auto 0;max-width:660px;padding:15px;border:none;border-radius:14px;background:var(--blue);color:#fff;font-family:"Hanken Grotesk",sans-serif;font-weight:800;font-size:16px;cursor:pointer}' +
      '@media print{body{background:#fff;padding:0}.pp{box-shadow:none;border-radius:0;max-width:none}.noprint{display:none}@page{margin:14mm}}' +
      '</style></head><body>' +
      '<div class="pp">' +
        '<div class="pp-top">' +
          '<div class="pp-eyebrow">McDuffy · Living Dog Passport</div>' +
          '<span class="pp-chip">McDuffy Member</span>' +
          '<div class="pp-id">' + avatar + '<div><h1 class="pp-name">' + esc(state.dog) + '</h1>' + (subtitle ? '<div class="pp-sub">' + esc(subtitle) + '</div>' : '') + '</div></div>' +
        '</div>' +
        '<div class="pp-body">' +
          (factGrid ? '<div class="pp-h">Profile</div><div class="pp-grid">' + factGrid + '</div>' : '') +
          (vaxRows ? '<div class="pp-h">Vaccines &amp; deworming</div><table class="vtab"><thead><tr><th>Shot</th><th>Given</th><th>Next due</th></tr></thead><tbody>' + vaxRows + '</tbody></table>' : '') +
          (vet.clinic ? '<div class="pp-h" style="margin-top:24px">Vet</div><div class="pp-vet"><b>' + esc(vet.clinic) + '</b>' + (vetContact ? '<div>' + esc(vetContact) + '</div>' : '') + '</div>' : '') +
          '<p class="pp-foot">Owner-kept record from McDuffy — yours to keep and share with ' + esc(state.dog) + '’s vet. Nutrition &amp; husbandry information only; not a medical record. Generated ' + fmtDay(new Date()) + '.</p>' +
        '</div>' +
      '</div>' +
      '<button class="noprint pbtn" onclick="window.print()">Print / Save as PDF</button>' +
      '</body></html>';
    var w = window.open('', '_blank');
    if (!w) { return; }
    w.document.open(); w.document.write(html); w.document.close();
  }

  function renderDone() {
    mount(
      '<div class="mds-wrap"><div class="mds-done">' + confettiHTML() +
        '<div class="mds-done__badge">' + I.crown + '</div>' +
        '<h1 class="mds-done__t">' + esc(state.dog) + '’s a full McDuffy member</h1>' +
        '<p class="mds-done__s">' + pr('{Her} page is ready — records, reminders and perks, all in one place.') + '</p>' +
        memberCardHTML() +
        '<div class="mds-carenudge">' + I.heart + '<div><b>Meet ' + esc(state.dog) + '’s care helper</b><span>Ask McDuffy anything, snap a vaccine card, or check ' + pr('{her}') + ' portions — it’s all on ' + pr('{her}') + ' page now.</span></div></div>' +
        quickActionsHTML() +
        '<button type="button" class="mds-cta" data-open-care>' + I.arrow + ' Open ' + esc(state.dog) + '’s care</button>' +
        '<button type="button" class="mds-cta mds-cta--ghost" data-passport>' + I.chip + ' Print / save ' + pr('{her}') + ' passport</button>' +
        '<button type="button" class="mds-cta mds-cta--ghost" data-see-order>See your order details ' + I.arrow + '</button>' +
      '</div></div>'
    );
    var oc = root.querySelector('[data-open-care]');
    if (oc) oc.addEventListener('click', function () { window.location.href = ACCOUNT; });
    var b = root.querySelector('[data-see-order]');
    if (b) b.addEventListener('click', function () { window.location.href = thankYouURL(); });
    var pp = root.querySelector('[data-passport]');
    if (pp) pp.addEventListener('click', printPassport);
  }
  function thankYouURL() {
    var qs = new URLSearchParams(location.search);
    var pass = new URLSearchParams();
    ['pi', 'ck', 'payment_intent_id', 'payment_intent_client_key', 'client_key', 'failed'].forEach(function (k) {
      var v = qs.get(k); if (v) pass.set(k, v);
    });
    var stored = readJSON('mcduffy_last_checkout') || {};
    var passPi = pass.get('pi') || pass.get('payment_intent_id') || '';
    var storedPi = String(stored.paymentIntentId || '');
    if (!passPi && storedPi) { pass.set('pi', storedPi); passPi = storedPi; }
    if (!pass.get('ck') && !pass.get('payment_intent_client_key') && !pass.get('client_key') &&
        passPi && storedPi === passPi && stored.clientKey) {
      pass.set('ck', String(stored.clientKey));
    }
    return THANKYOU + (pass.toString() ? '?' + pass.toString() : '');
  }

  /* ---------- payment-verification gate (this page is the post-pay landing) ----------
     We only celebrate a CONFIRMED payment. PayMongo returns with pi+ck are
     checked against the provider. Anything failed or
     uncertain (pending, missing keys) → hand off to /pages/paymongo-return, which
     owns the robust verification + failure/retry UI. A no-params visit = a returning
     member managing their page → show it. */
  var PM_PUBLIC_KEY = 'pk_live_p9wh5cRZQm3ZoVJLHSU8FSQV';
  function forwardToThankYou() { location.replace(THANKYOU + location.search); }
  function checkPI(pi, ck, tries) {
    tries = tries || 0;
    return fetch('https://api.paymongo.com/v1/payment_intents/' + encodeURIComponent(pi) + '?client_key=' + encodeURIComponent(ck), {
      headers: { 'Authorization': 'Basic ' + btoa(PM_PUBLIC_KEY + ':') }
    }).then(function (r) {
      if (!r.ok) { return tries < 2 ? new Promise(function (res) { setTimeout(res, 1500); }).then(function () { return checkPI(pi, ck, tries + 1); }) : false; }
      return r.json().then(function (d) {
        var a = d && d.data && d.data.attributes;
        var st = a && a.status;
        var pays = (a && a.payments) || [];
        var last = pays.length ? pays[pays.length - 1] : null;
        var pst = last && last.attributes ? last.attributes.status : '';
        return st === 'succeeded' || pst === 'paid';
      });
    }).catch(function () { return false; });
  }
  function verifyPaymentGate() {
    var q;
    try { q = new URL(location.href).searchParams; } catch (e) { return Promise.resolve(true); }
    var pi = q.get('pi') || q.get('payment_intent_id');
    var ck = q.get('ck') || q.get('payment_intent_client_key') || q.get('client_key') || '';
    if (pi && !ck) {
      var stored = readJSON('mcduffy_last_checkout') || {};
      if (String(stored.paymentIntentId || '') === String(pi) && stored.clientKey) ck = String(stored.clientKey);
    }
    if (pi && ck) return checkPI(pi, ck).then(function (okStatus) { if (okStatus) return true; forwardToThankYou(); return false; });
    if (pi || q.get('ok') || q.get('failed') || q.get('paypal') || q.get('subscription_id')) {
      forwardToThankYou();
      return Promise.resolve(false);
    }
    return Promise.resolve(true); // no payment params → direct manage visit
  }

  /* ---------- boot ---------- */
  verifyPaymentGate().then(function (proceed) {
    if (!proceed) return; // handed off to the thank-you page
    bootstrapFromConfig();
    root.addEventListener('click', onWelcomeClick); // single delegated listener (survives re-renders)
    renderWelcome();               // paint immediately from the checkout config
    hydrateFromServer().then(function () {
      if (!activeSheet) renderWelcome();
    });
  });
})();
